import type {ReactNode} from 'react'
import {useViewerRoles} from '../shared/use-viewer-roles'
import type {ForYouViewerRoles} from '../shared/use-viewer-roles'
import {useAuthorOrAssigneeDecider} from './Author'
import {useReviewerDecider} from './Reviewer'
import {useVisitorDecider} from './Visitor'

export type ViewerRole = 'author' | 'reviewer' | 'visitor'

export function useDecideNextAction() {
  const roles = useViewerRoles()
  const decideAuthorOrAssigneeAction = useAuthorOrAssigneeDecider()
  const decideReviewerAction = useReviewerDecider()
  const decideVisitorAction = useVisitorDecider()

  return decideNextAction({
    roles,
    authorOrAssigneeAction: decideAuthorOrAssigneeAction,
    reviewerAction: decideReviewerAction,
    visitorAction: decideVisitorAction,
  })
}

// Data-agnostic function that can be used in tests to verify the correct action is selected for a given role.
export function decideNextAction({
  roles,
  authorOrAssigneeAction,
  reviewerAction,
  visitorAction,
}: {
  roles: ForYouViewerRoles
  authorOrAssigneeAction: ReactNode
  reviewerAction: ReactNode
  visitorAction: ReactNode
}): ReactNode {
  if (roles.isAuthor || roles.isAssignee) {
    return authorOrAssigneeAction
  }

  if (roles.isReviewer) {
    return reviewerAction ?? visitorAction
  }

  return visitorAction
}
